// Vendor inbox — triage surface for the quotes@ email intake (Slice 13).
//
// Mirror of the Vendors page layout: list on the left, detail/triage on the
// right. The list shows queued intakes (parser ran, but the row needs a human
// decision); the detail pane lets the broker assign a parsed quote to a line,
// discard noise, or mark an auto-committed quote reviewed.

import { useRoute, useLocation } from 'wouter';
import { Inbox, ArrowLeft } from 'lucide-react';
import { AppShell } from '@/components/app-shell';
import { VendorInboxList } from '@/components/vendor-inbox-list';
import { VendorInboxDetail } from '@/components/vendor-inbox-detail';

export function VendorInboxPage() {
  const [match, params] = useRoute('/vendor-inbox/:publicId');
  const selectedId = match ? params.publicId : null;
  const [, setLocation] = useLocation();

  return (
    <AppShell
      title="Vendor inbox"
      subtitle="Vendor quotes auto-ingested from quotes@ — triage what didn't auto-commit"
      headerActions={
        selectedId ? (
          <button
            onClick={() => setLocation('/vendor-inbox')}
            className="lg:hidden btn-ghost px-2"
            aria-label="Back to inbox list"
          >
            <ArrowLeft className="w-4 h-4" />
            Back
          </button>
        ) : undefined
      }
    >
      <div className="h-full lg:grid lg:grid-cols-[minmax(380px,42%)_1fr] overflow-hidden">
        <aside
          className={`h-full border-r border-border overflow-hidden bg-surface ${
            selectedId ? 'hidden lg:block' : 'block'
          }`}
        >
          <VendorInboxList selectedId={selectedId} />
        </aside>
        <section
          className={`h-full overflow-hidden bg-surface ${
            selectedId ? 'block' : 'hidden lg:block'
          }`}
        >
          {selectedId ? (
            <VendorInboxDetail key={selectedId} publicId={selectedId} />
          ) : (
            <div className="h-full flex items-center justify-center px-8">
              <div className="text-center max-w-md">
                <div className="w-12 h-12 mx-auto rounded-full bg-primary-muted text-primary-strong flex items-center justify-center mb-3">
                  <Inbox className="w-6 h-6" />
                </div>
                <p className="text-sm text-foreground-muted">
                  Select an intake on the left to triage it. Single-quote emails that
                  matched exactly one open line auto-commit (and show here as{' '}
                  <span className="font-medium text-foreground">auto-committed</span> for a
                  quick review).
                </p>
              </div>
            </div>
          )}
        </section>
      </div>
    </AppShell>
  );
}
